/* ============================================================
   HONEY BAE | the offer module

   ONE NUMBER, and everything else is arithmetic off it. The store sells a
   single variant at a single list price and discounts it with Shopify's own
   selling plans, so there is no bundle ladder here and nothing to model: the
   whole offer is a list price and a plan percentage, both read off the live
   product 2026-08-15 from
   https://tryhoneybae.com/products/honey-bae-natural-honey.js

     variant      48389064163542, "Default Title", $34.95, no compare-at
     plan group   "Subscribe and save"
       7424934102   1-Month Delivery   10% off
       7468679382   2-Month Delivery   20% off
       7468712150   3-Month Delivery   30% off   <- the one the script names

   The supplied script quotes $24.47 a pack against $34.95, which is exactly
   what 30% off computes to, so the client's figure and the store agree and no
   override is needed here. If they ever disagree, the store wins and this file
   is where that gets recorded, the way Veyla's PRICE_OVERRIDE does.

   money() is a formatter and nothing else. There is no currency layer on this
   store and no multi-currency lander, so a price is dollars and cents.
   ============================================================ */
(() => {

  /* The list price the store itself publishes, in cents. Every figure the
     lander prints derives from this and PLANS below. */
  const LIST_CENTS = 3495;

  const PLANS = {
    m1: { id: '7424934102', label: '1-Month Delivery', offPct: 10 },
    m2: { id: '7468679382', label: '2-Month Delivery', offPct: 20 },
    m3: { id: '7468712150', label: '3-Month Delivery', offPct: 30 }
  };

  /* The plan the supplied script names, and the one the page is about. */
  const PLAN_DEFAULT = 'm3';

  const PRODUCT = {
    handle:   'honey-bae-natural-honey',
    url:      '/products/honey-bae-natural-honey',
    title:    'Honey Bae Natural Honey',
    variantId: '48389064163542',
    sachets:  12,
    gramsPerSachet: 15
  };

  /* Shopify applies a percentage adjustment and rounds to the cent, which is
     why 30% of $34.95 prints as $24.47 rather than $24.465. Math.round is the
     same rounding, so the page and the cart agree. */
  const planCents = key => Math.round(LIST_CENTS * (1 - PLANS[key].offPct / 100));

  /* Measured against the list price the STORE publishes. Never against a
     comparison figure invented for the lander. */
  const planSavePct = key => PLANS[key].offPct;
  const planSaveCents = key => LIST_CENTS - planCents(key);

  /* Per-day, which is how the store's own announcement bar talks. 12 sachets a
     pack, one sachet a serving, so a pack is 12 servings. */
  const perServingCents = key => planCents(key) / PRODUCT.sachets;

  const money = cents =>
    '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  window.HB_OFFER = {
    LIST_CENTS, PLANS, PLAN_DEFAULT, PRODUCT,
    planCents, planSavePct, planSaveCents, perServingCents, money
  };
})();
